// "Neu" marker for items an update run first saw within the last
// NEW_DAYS days (`first_seen`, set by scraper/change_tracking.py). Items
// from full/reset scrapes carry no first_seen and never show it.
export const NEW_DAYS = 7;

export function isNew(firstSeen) {
  if (!firstSeen) return false;
  const t = Date.parse(firstSeen);
  return Number.isFinite(t) && Date.now() - t < NEW_DAYS * 24 * 60 * 60 * 1000;
}

export default function NewBadge({ firstSeen, className = "" }) {
  if (!isNew(firstSeen)) return null;
  return (
    <span
      className={`inline-flex items-center shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider border border-red-500/40 bg-[#D32222]/15 text-red-400 ${className}`}
      title={`Neu seit ${new Date(firstSeen).toLocaleDateString("de-DE")}`}
      data-testid="new-badge"
    >
      Neu
    </span>
  );
}
